import React from 'react';
import {connect} from 'react-redux';
import cs from 'classnames'
import mapDispatch from '~/misc/mapDispatch';
import {push as changeURL} from 'react-router-redux';
import css from './index.css';
import {userDispatcher} from '~/misc/userAccount';
import {modalChange} from '~/modules/modal/actions';
import * as modes from '~/modules/modal/modes';
class VerifyStatus extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const { hint, gotoDot, linkStatus, w9formStatus, phoneVerify, emailVerify, needL1} = this.props;
    
    if(!linkStatus || linkStatus === "Linked" || linkStatus === "Invalidate"|| w9formStatus === "Verified") {
      return null;
    }

    const dispatcher = () => {
      if(!phoneVerify && !emailVerify) {
        return {
          type: "needL1",
          message: hint,
        }
      }
      if(!phoneVerify) {
        return {
          type: "needL1",
          message: "Please verify your phone number before uploading your documents.",
        }
      }
      if(!emailVerify) {
        return {
          type: "needL1",
          message: "Please verify your email before uploading your documents.",
        }
      }
      if(w9formStatus === 'Pending') {
        return { 
          type: "pending", 
          message: hint,
        }
      }
      if(phoneVerify && emailVerify) {
        return {
          type: "warning",
          message: hint,
        }
      }
    }
    const {type, message}  = dispatcher();
    return (
      <div className={css.warp}>
        <div className={cs(css.hint, css["hint-"+type])}>
          <div>{message}</div>
          {
            ['needL1', 'warning'].includes(type) ? 
              <div className={css.btn} onClick={()=> {
                if(type === "needL1")  needL1(message);
                if(type === "warning") gotoDot();
              }}>
                Upload
              </div>
              : <div className={css.fakeBtn}></div>
          }
        </div>
      </div>
      
    )
  }
}

export default connect(
  ({user}) => ({
    hint: user.profileVerificate&&user.profileVerificate.promptLanguage ,
    w9formStatus: user.profileVerificate&&user.profileVerificate.w9formStatus,
    linkStatus: user.profileVerificate&&user.profileVerificate.linkedStatus,
    phoneVerify: user.verified_phone,
    emailVerify: user.emailVerified
  }
), mapDispatch({
  gotoDot:(props, url) => changeURL(userDispatcher()+'/dot-verify'),
  needL1: (props, message) => modalChange(modes.NEED_L1,  {type: 'askPop', popUpMessage: message}),
  
}))(VerifyStatus);



// WEBPACK FOOTER //
// ./src/components/pages/MyAccount/share/VerifyStatus/index.js